<template>
  <body class="home">
  <el-container class="home">
    <el-main>
      <div class="el_col">
        <img src="../assets/tab_img.jpg" alt="logo" class="img_title">

        <div class="el_col" style="align-items: flex-start;width: 70%;margin-top: 10px">
          <img src="../assets/step.gif" style="width: 300px" alt="输入手机号">
        </div>
        <el-input class="el_phone_input" type="number" maxlength="11"
                  v-model="phone"
                  :placeholder="input_phone_hinder"
                  :pattern="pone_pattern"
                  @focus="handleFocus"
        />
        <!--        <div class="el_row">-->
        <!--          <el-input class="el_code_input" type="number" maxlength="4"-->
        <!--                    v-model="code"-->
        <!--                    :placeholder="input_code_hinder"-->
        <!--                    :pattern="code_pattern"-->
        <!--          />-->
        <!--          <CodeView :phone="phone"/>-->
        <!--        </div>-->

        <img src="../assets/get.png" @click="getGo()" class="img">

        <div class="el_row" style="text-align: left;width: 80%">
          <!--          <input type="checkbox" :value="checked" :checked="checked" @onclick="handleCheckChanged"/>-->
          <el-checkbox @change="handleCheckChanged" v-model="checked" size="large"/>
          <p style="margin-left: 10px;color: white"> 我已阅读并同意<span  style="border-bottom: rgba(255, 239, 0, 1) solid 1px;"
            @click="readInfo2()">《服务协议》</span>及<span  style="border-bottom: rgba(255, 239, 0, 1) solid 1px;"
            @click="readInfo()">《隐私政策》</span>，知悉业务说明并用该号码登录办理
          </p>
        </div>

        <div class="el_row">
          <p class="font_size">
            开通咪咕悦看超级会员,<strong>标准资费20元/月</strong>，
            以<strong>话费支付</strong>，具体以实际扣费为准，
            支付成功后<strong>立即生效，有效期3年（36个自然月），如双方在有效期届满前无异议，有效期自动续展，每次续展3年。有效期内变更/退订/销户/携转，无需承担相应的违约责任。</strong>
            可随时取消，取消<strong>立即生效</strong>,当前周期内可继续享受权益，次月起不再扣费。
          </p>
        </div>

        <strong style="font-size: 20px;text-align: center;color:white">客服热线：4001009886</strong>
        <img src="../assets/ad.jpg" alt="logo" class="img_title">
        <!--        <img src="../assets/ad1.png" alt="logo" style="margin-top: 20px" class="img_title">-->
        <!--        <p style="color: white;font-size: 20px;">业务规则</p>-->
        <div class="el_col"
             style="color: white;font-size: 18px;align-items: flex-start;text-align: left;">
          <img src="../assets/guize.png" alt="logo" class="img_title">
          <img src="../assets/slogin.png" alt="logo" class="img_title">
        </div>
      </div>

    </el-main>

    <el-dialog
      v-model="centerDialogVisible"
      width="500"
      align-center
    >
      <div style="width: 100%;text-align:left;font-size: 20px ">
        <p>尊敬的客户：</p>
        <p>根据《中华人民共和国反恐怖主义法》、
          《全国人民代表大会常务委员会关于加强网络信息保护的决定》、
          《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）等国家法律法规的要求，
          为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。</p>
        <p> 为向客户提供优质、个性化的服务，包括但不限于提供通信服务、
          保障通信服务安全、改善服务质量、推介个性化产品等，
          我公司将遵循合法、正当、必要的原则，
          按照法律法规规定或协议约定使用留存客户个人信息，
          并妥善保管，严格保密，依法保护客户个人信息。</p>
      </div>
    </el-dialog>
    <el-dialog
      v-model="serviceDialogVisible"
      width="500"
      align-center
    >
      <div style="width: 100%;text-align:left;font-size: 20px ">
        <p>尊敬的客户：</p>
        <p>请您务必仔细阅读并了解本《服务协议》（以下简称为“服务协议”）。对于重要条款我们采用粗体及下划线方式进行显著标注以提示您注意。您一旦主动在页面填写您的个人信息并进行提交操作，即意味着您同意我们按照本声明收集、使用、共享您的相关信息。若您不接受本声明，请勿登记您的个人信息。我们的页面和服务主要面向成人。我们不会主动收集未成年人的个人信息，如果您未满18周岁，请您在监护人陪同下仔细阅读并充分理解本声明，并征得监护人的同意后使用我们的服务或向我们提供信息。</p>
        <p>一、收集信息的原则及目的</p>
        <p>保障为您所提供的产品或服务功能的正常实现。2.实现对您的推送功能。3.帮助我们维护和改进我们的产品或服务，提升用户体验。</p>
        <p>二、如何收集和使用您的个人信息</p>
        <p>我们将合法合规对您的个人信息进行采集、使用。您已知晓并同意在您下次浏览本落地页面时，我们会帮您预先填写您上次输入的历史信息以提升您的使用体验。您亦可拒绝使用预填充功能。（一）收集和使用您的个人信息的范围 1.下单及订单管理 为了向您配送货物或提供相关服务，当您准备登记您的信息以促成交易的达成时，我们将相应收集您的姓名、手机号、地址、性别和身份证号码（仅特殊行业需要，如运营商、保脸）。同时，所涉订单中会鼓明订单编号、您所购买的商品或服务信息、下单时间等。具体需要填写的信息可能会根据我们提供的产品/服务的不同而有所差异，请以届时向您展示的产品/服务以及所对应的要求填写相关个人信息。2.广告的定向推送 为实现广告推送功能，在您进入本广告页面并同意本声明时，我们还可能会收集您的产品与/或服务的设备信息，包括网络身份标识信息（手机IPV4地址、IP）、网络信息、手机硬件信息（电量、品牌、型号、内存、屏幕分辨率、CPU信息）和运营商信息、操作日志。（二）例外 对于《信息安全技术个人信息安全规范》5.6中规定的情形，我们收集、使用您的个人信息无需事先征得您的授权同意。</p>
        <p>三、如何共享、转让您的个人信息</p>
        <p>（一）共享 仅为实现本声明之目的，我们可能会与关联公司、合作伙伴共享您的某些个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的合规协定或做类似要求，以规范其处理个人信息的行为，并促使其具备个人信息的安全保障能力。我们将与以下授权合作伙伴共享您的信息：1.供应商、服务提供商和其他合作伙伴（包括相关代理商）。为向您进行货物配送及提供服务，我们可能会将您主动登记提供的信息向该商品及服务的提供商，以及为此目的所涉及的必要第三方进行共享，并由其在您已经向其授权的范围内使用，包括向您发送货物或与您进行必要的联系。2.广告、分析服务类的授权合作伙伴。我们可能会将您的匿名化或去标识化的个人信息及您的设备信息与广告、分析服务类的授权合作伙伴共享，以帮助其在不识别您的个人身份的前提下提升广告有效触达率。（二）转让 我们不会将您的个人信息转让给任何第三方，但基于您的明确同意或法律法规要求或涉及合并、收购、分立、重组或破产清算的情况除外。</p>
        <p>四、如何保存与保护您的个人信息</p>
        <p>我们的信息保护规则：1.收集到您的个人信息后，在保障供应商、服务提供商和其他合作伙伴或必要第三方能够凭借相关信息进行货物发送或服务提供的基础上，我们将通过技术手段及时对数据进行匿名化或去标识化处。2.我们已使用符合业界标准的安全防护撸施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露等。3.如果我们的管理防护设施遭到破坏，导致信息被非授权访问、公开披露、幕改或毁坏，我们将及时将事件相关情况及时向您告知，难以逐一告知时，我们会采取公告的方式。同时，我们还将主动上报个人信息安全事件的处置情况。我们的信息保存方式：1.保存期限：您提供的个人信息，将在上文所声明的服务提供过程中持续授权我们使用。在您删除个人信息时，我们将视为您撒回了对于该等个人信息收集、使用或共享的授权和同意。2.保存地域：原则上，我们所采集到的您的个人信息将存储在中国。</p>
        <p>五、您对个人信息享有的权利</p>
        <p>按照中国相关的法律、法规、标准，我们保障您对自己的个人信息的更正权、删除权或授权撇回等相关权益。为实现本第五条所述权利，您可通过本声明第七条“如何联系我们”中所列明的联系方式与我们进行联系，我们在验证主体身份，确认相关要求和理由后，为您进行相应的更正、到除及授权撤回。</p>
        <p>六、政策更新</p>
        <p>基于服务优化或情况变更等事由，本声明会不定期进行更新。更新版本将通过在官方网站、广告落地页面等我们正在运营或进行合作的各类相关产品中发出，也请您访问我们网站及软件以便及时了解最新的《服务协议》。</p>
        <p>七、联系我们</p>
        <p>您可通过广告落地页中的客服电话联系我们，我们将会在15个工作日内给您反馈。</p>
      </div>
    </el-dialog>
    <CustomDialog v-if="showToast" :close="handColse"/>

  </el-container>
  </body>

</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import CodeView from '@/components/CodeView.vue'
import RowScollView from '@/components/RowScollView.vue'
import { post } from '@/api/phone'
import { ElLoading } from 'element-plus'
import CustomDialog from '../components/CustomDialogComponent.vue'
import { aesEncrypt } from '@/utils/encrypt'
import { encodeBase64 } from '@/utils/tools'
import CryptoJS from 'crypto-js'

@Options({
  components: {
    CodeView,
    RowScollView,
    CustomDialog
  },
  data () {
    return {
      input_phone_hinder: '请输入手机号',
      pone_pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
      code_pattern: /^[0-9]{4}$/,
      phone: '',
      code: '',
      input_code_hinder: '请输入验证码',
      checked: false,
      centerDialogVisible: false,
      serviceDialogVisible: false,
      chanelId: 'M3HO0001',
      toastDialogVisible: true,
      successMessage: '支付成功',
      toastImageSrc: require('@/assets/toast.png'),
      showToast: false,
      contentId: '',

      sdkTraceId: '',
      entrySource: '',
      sourceType: '1',
      sourcePlat: '6',
      global_platform: '99',
      pageSeq: 1,
      channel_id: 'M3HO0001',
      company_id: 'MG003',
      company_name: '咪咕数媒',

      pageLoadTime: 0,
      domContentLoadedTime: 0,
      pageEnterTime: 0,
      step: 0,
      encryptedPhone: '',
      province: '',
      city: '',
      // chanelId: 'M3140070'
      orderId: '',
      goodsId: '',

      projectId: '8d2279a5e2f18b7c',
      ServerHost: 'collect.gmcc.net',
      DatasourceId: '9d59ac736f01c688',
      pageName_var: '咪咕悦看超级会员',
      goodsId_var: '1000019093',
      goodsName_var: '咪咕悦看超级会员',
      key: '9e5702ead4d643fd', // 密钥必须是16字节
      // merchantsId_var: 'GDOPEN_2009813',
      merchantsId_var: 'M3H9',
      merchants_var: '无锡妙美网络科技有限公司',
      merchantsIdCity_var: '广东',
      // global_merchantsId_var:'2200000002110801534',// 商户id
      global_merchantsId_var: '0000000005320300003', // 商户id
      global_merchants_var: '咪咕数媒' // 商户名称
      // chanelId: 'M3140070'

    }
  },
  created (): any {
    this.getContentIDFromURL()
  },
  methods: {
    uploadPageStayTime () {
      const stayTime = Date.now() - this.pageEnterTime

      window.AmberWebSdk._amberTrack('qingyuan_page_stay',
        [
          {
            EK: 'stayTime',
            EV: stayTime
          },
          {
            EK: 'sdkTraceId',
            EV: this.sdkTraceId.toString()
          },
          {
            EK: 'entrySource',
            EV: this.entrySource.toString()
          },
          {
            EK: 'sourceType',
            EV: this.sourceType.toString()
          },
          {
            EK: 'sourcePlat',
            EV: this.sourcePlat.toString()
          },
          {
            EK: 'globalPlatform',
            EV: this.global_platform.toString()
          },
          {
            EK: 'pageSeq',
            EV: this.pageSeq
          },
          {
            EK: 'channelId',
            EV: this.channel_id
          },
          {
            EK: 'companyId',
            EV: this.company_id
          },
          {
            EK: 'companyName',
            EV: this.company_name
          }
        ])
      this.step = this.step + 1
      if (this.phone !== '' && this.orderId !== '') {
        window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
          {
            EK: 'sdkTraceId',
            EV: this.sdkTraceId.toString()
          },
          {
            EK: 'entrySource',
            EV: this.entrySource.toString()
          },
          {
            EK: 'sourceType',
            EV: this.sourceType.toString()
          },
          {
            EK: 'sourcePlat',
            EV: this.sourcePlat.toString()
          },
          {
            EK: 'globalPlatform',
            EV: this.global_platform.toString()
          },
          {
            EK: 'pageSeq',
            EV: this.pageSeq
          },
          {
            EK: 'channelId',
            EV: this.channel_id
          },
          {
            EK: 'companyId',
            EV: this.company_id
          },
          {
            EK: 'companyName',
            EV: this.company_name
          },
          {
            EK: 'setGeneralProps',
            EV: {
              globalTypes: '1',
              globalOptType: '1'
            }
          },
          {
            EK: 'bussinessProcessing',
            EV: {
              processId: this.step,
              processType: '9',
              apiId: 'SDK',
              apiName: '办理SDK',
              resultCode: '0',
              phoneNumber: this.encryptedPhone,
              payMethod: '3',
              fee: '20',
              channelId: this.channel_id,
              cpId: '999999',
              orderId: this.orderId,
              goodsId: this.goodsId,
              goodsName: '咪咕悦看超级会员'
            }
          }

        ])
      }
    },

    handleFocus () {
      // this.encryptPhone()
      window.gdp('track', 'professional_merchants_bussinessProcessing', {
        businessType_var: '存量', // 属于存量业务则写“存量”
        goodsId_var: this.goodsId_var, // 业务办理时所属的商品ID或者业务ID
        goodsName_var: this.goodsName_var, // 业务办理时商品名称。
        goodsType_var: '新业务', // 业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
        apiId_var: 'SDK', // 调用接口id；如果是通过SDK办理的，该字段传【SDK】
        apiName_var: '办理SDK', // 调用接口名称；如果是通过SDK办理的，该字段传【办理SDK】
        merchantsId_var: this.merchantsId_var, // 商品所属商户id或者渠道号
        merchants_var: this.merchants_var, // 商品所属商户名称或者渠道名称
        merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
        phoneNumber_var: '', // 输入电话号码,传AES加密后的手机号
        processType_var: '输入手机号码', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码(点击输入框时触发)、立即办理、前往办理(拉起统一支付页面时触发)、获取短信验证码、输入短信验证码、提交订单、办理成功、办理失败、支付成功、支付失败等）
        errorMessage_var: '', // 业务办理失败时的失败原因明细。（如：网络问题、业务互斥……）
        channelId_var: '', // 下单渠道编码，没有则不传
        operatorId_var: '', // 下单工号，没有则不传
        payType_var: '话费', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
        merchantsOrder_var: '', // 自建的订单号。
        orderNumber_var: '', // 接口返回的订单号。
        ordertype_var: '新业务订单' // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
      })
    },
    handlePageUnload () {
      this.uploadPageStayTime()
    },
    getContentIDFromURL () {
      const urlParams = new URLSearchParams(window.location.search)
      this.contentId = urlParams.get('cpid') || ''
      console.log('Fetched contentID:', this.contentId)
    },
    encryptPhone () {
      const key = CryptoJS.enc.Utf8.parse(this.key)
      const iv = CryptoJS.enc.Utf8.parse('')
      const encrypted = CryptoJS.AES.encrypt(this.phone, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7
      })
      console.log('encrypted.toString():', encrypted.toString())
      return encrypted.toString()
    },
    handleCheckChanged () {
      if (!this.phone.trim()) {
        this.checked = false
        this.$message({
          message: '请填写手机号',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }
      return this.checked
    },
    readInfo () {
      this.centerDialogVisible = !this.centerDialogVisible
    },
    readInfo2 () {
      this.serviceDialogVisible = !this.serviceDialogVisible
    },
    handColse () {
      this.showToast = false
    },
    calculatePageLoadTime () {
      const perfData = window.performance.timing

      this.domContentLoadedTime = perfData.domContentLoadedEventEnd - perfData.navigationStart

      if (perfData.loadEventEnd > 0) {
        this.pageLoadTime = perfData.loadEventEnd - perfData.navigationStart
      } else {
        this.pageLoadTime = Date.now() - perfData.navigationStart
      }

      console.log('页面加载时间统计：')
      console.log(`DOM内容加载完成时间: ${this.domContentLoadedTime}ms`)
      console.log(`页面完全加载时间: ${this.pageLoadTime}ms`)

      window.AmberWebSdk._amberTrack('qingyuan_page_load', [
        {
          EK: 'sdkTraceId',
          EV: this.sdkTraceId.toString()
        },
        {
          EK: 'entrySource',
          EV: this.entrySource.toString()
        },
        {
          EK: 'sourceType',
          EV: this.sourceType.toString()
        },
        {
          EK: 'sourcePlat',
          EV: this.sourcePlat.toString()
        },
        {
          EK: 'globalPlatform',
          EV: this.global_platform.toString()
        },
        {
          EK: 'pageSeq',
          EV: this.pageSeq
        },
        {
          EK: 'channelId',
          EV: this.channel_id
        },
        {
          EK: 'companyId',
          EV: this.company_id
        },
        {
          EK: 'companyName',
          EV: this.company_name
        },
        {
          EK: 'resultCode',
          EV: 0
        },
        {
          EK: 'loadTime',
          EV: this.pageLoadTime
        }
      ])
    },
    async getGo () {
      console.log('getGo')
      if (!this.checked) {
        return this.$message({
          message: '请阅读并同意《个人信息保护政策》',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }

      if (this.phone.length === 0) {
        return this.$message({
          message: '请输入手机号',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }
      this.encryptedPhone = aesEncrypt(this.phone)
      try {
        // 显示加载状态
        const loading = ElLoading.service({
          lock: true,
          text: '查询中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 拼接完整的请求地址
        const apiUrl = `https://tools.hooting.cn/api/tools/get-phone-province?phone=${this.phone}`

        // 使用原生 fetch 发起 GET 请求
        const response = await fetch(apiUrl)

        // 解析返回的 JSON 数据
        const result = await response.json()

        // 关闭加载
        loading.close()

        console.log('接口返回结果：', result)

        // ⚠️ 注意：这里需要根据该接口的实际返回结构进行调整
        // 假设接口成功时返回 code === 200 或 success === true
        if (result.code === 0 && result.data) {
          this.province = result.data.province_code
          this.city = result.data.city_code

          // 可以在这里做弹窗提示或赋值给 data 里的变量
          // this.$message.success(`号码归属地：${province}`);
        } else {
          this.$message.error(result.message || '查询失败，请重试')
        }
      } catch (error) {
        console.error('查询接口请求异常：', error)
        this.$message.error('网络异常，请检查网络后重试')
      }
      this.step = this.step + 1
      window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
        {
          EK: 'sdkTraceId',
          EV: this.sdkTraceId.toString()
        },
        {
          EK: 'entrySource',
          EV: this.entrySource.toString()
        },
        {
          EK: 'sourceType',
          EV: this.sourceType.toString()
        },
        {
          EK: 'sourcePlat',
          EV: this.sourcePlat.toString()
        },
        {
          EK: 'globalPlatform',
          EV: this.global_platform.toString()
        },
        {
          EK: 'pageSeq',
          EV: this.pageSeq
        },
        {
          EK: 'channelId',
          EV: this.channel_id
        },
        {
          EK: 'companyId',
          EV: this.company_id
        },
        {
          EK: 'companyName',
          EV: this.company_name
        },
        {
          EK: 'clickElement',
          EV: '#postbtn'
        },
        {
          EK: 'setGeneralProps',
          EV: {
            globalTypes: '1',
            globalOptType: '1'
          }
        },
        {
          EK: 'bussinessProcessing',
          EV: {
            processId: this.step,
            processType: '1',
            phoneNumber: this.encryptedPhone,
            resultCode: '0',
            apiId: 'SDK',
            apiName: '办理SDK'
          }
        }
      ])

      this.checkGo()
    },
    async checkGo () {
      this.step = this.step + 1
      window.AmberWebSdk._amberTrack('qingyuan_user_login', [
        {
          EK: 'sdkTraceId',
          EV: this.sdkTraceId.toString()
        },
        {
          EK: 'entrySource',
          EV: this.entrySource.toString()
        },
        {
          EK: 'sourceType',
          EV: this.sourceType.toString()
        },
        {
          EK: 'sourcePlat',
          EV: this.sourcePlat.toString()
        },
        {
          EK: 'globalPlatform',
          EV: this.global_platform.toString()
        },
        {
          EK: 'pageSeq',
          EV: this.pageSeq
        },
        {
          EK: 'channelId',
          EV: this.channel_id
        },
        {
          EK: 'companyId',
          EV: this.company_id
        },
        {
          EK: 'companyName',
          EV: this.company_name
        },
        {
          EK: 'phoneProvince',
          EV: this.province
        },
        {
          EK: 'phoneCity',
          EV: this.city
        },

        {
          EK: 'account',
          EV: this.encryptedPhone
        },
        {
          EK: 'accountType',
          EV: '1'
        },
        {
          EK: 'phoneNumber',
          EV: this.encryptedPhone
        },
        {
          EK: 'resultCode',
          EV: '0'
        }
      ])
      this.createOder()
    },
    async createOder () {
      const loading = ElLoading.service({
        lock: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const response = await post<{
          code: string,
          msg: string,
          channel: string,
          miguOrderId: string,
          productId: string,
          misidn: string
        }>('/orderActivity', {
          mobile: this.phone,
          cpid: this.contentId,
          channelCode: this.chanelId
        })
        console.log(response)

        if (response.code === '0') {
          this.step = this.step + 1
          console.log(this.step)
          window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
            {
              EK: 'sdkTraceId',
              EV: this.sdkTraceId.toString()
            },
            {
              EK: 'entrySource',
              EV: this.entrySource.toString()
            },
            {
              EK: 'sourceType',
              EV: this.sourceType.toString()
            },
            {
              EK: 'sourcePlat',
              EV: this.sourcePlat.toString()
            },
            {
              EK: 'globalPlatform',
              EV: this.global_platform.toString()
            },
            {
              EK: 'pageSeq',
              EV: this.pageSeq
            },
            {
              EK: 'channelId',
              EV: this.channel_id
            },
            {
              EK: 'companyId',
              EV: this.company_id
            },
            {
              EK: 'companyName',
              EV: this.company_name
            },
            {
              EK: 'phoneProvince',
              EV: this.province
            },
            {
              EK: 'userId',
              EV: this.encryptedPhone
            },
            {
              EK: 'phoneCity',
              EV: this.city
            },
            {
              EK: 'clickElement',
              EV: '#postbtn'
            },
            {
              EK: 'setGeneralProps',
              EV: {
                globalTypes: '1',
                globalOptType: '1'
              }
            },
            {
              EK: 'bussinessProcessing',
              EV: {
                processId: this.step,
                processType: '2',
                phoneNumber: this.encryptedPhone,
                resultCode: '0',
                apiId: 'SDK',
                apiName: '办理SDK'
              }
            }
          ])
          if (response) {
            const payjson = {
              orderId: response.data.miguOrderId,
              channelCode: response.data.channel,
              productId: response.data.productId,
              misidn: response.data.misidn,
              actionType: '1'
            }
            loading.close()
            this.goodsId = response.data.productId
            this.orderId = response.data.miguOrderId
            window.gdp('setUserAttributes', {
              operators_var: '移动', // 赋值运营商名称（移动、联通、电信）。
              prov_var: '广东', // 赋值省份名称。
              city_var: '广州' // 赋值地市名称。
            })
            window.gdp('track', 'professional_merchants_bussinessProcessing', {
              businessType_var: '存量', // 属于存量业务则写“存量”
              goodsId_var: this.goodsId_var, // 业务办理时所属的商品ID或者业务ID
              goodsName_var: this.goodsName_var, // 业务办理时商品名称。
              goodsType_var: '新业务', // 业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
              apiId_var: 'SDK', // 调用接口id；如果是通过SDK办理的，该字段传【SDK】
              apiName_var: '办理SDK', // 调用接口名称；如果是通过SDK办理的，该字段传【办理SDK】
              merchantsId_var: this.merchantsId_var, // 商品所属商户id或者渠道号
              merchants_var: this.merchants_var, // 商品所属商户名称或者渠道名称
              merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
              phoneNumber_var: this.encryptPhone(), // 输入电话号码,传AES加密后的手机号
              processType_var: '前往办理', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码(点击输入框时触发)、立即办理、前往办理(拉起统一支付页面时触发)、获取短信验证码、输入短信验证码、提交订单、办理成功、办理失败、支付成功、支付失败等）
              errorMessage_var: '', // 业务办理失败时的失败原因明细。（如：网络问题、业务互斥……）
              channelId_var: '', // 下单渠道编码，没有则不传
              operatorId_var: '', // 下单工号，没有则不传
              payType_var: '', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
              merchantsOrder_var: '', // 自建的订单号。
              orderNumber_var: response.data.miguOrderId, // 接口返回的订单号。
              ordertype_var: '新业务订单' // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
            })

            window.MiguSdk.migupay(payjson, (resultCode, msg, data) => {
              console.log(data)
              console.log(resultCode)
              console.log(msg)
              this.step = this.step + 1
              if (resultCode.toString() === '0000' || resultCode.toString() === '4901') {
                // this.$message({
                //   message: '支付成功',
                //   type: 'success',
                //   center: true,
                //   offset: window.screen.height / 2
                // })

                window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
                  {
                    EK: 'sdkTraceId',
                    EV: this.sdkTraceId.toString()
                  },
                  {
                    EK: 'entrySource',
                    EV: this.entrySource.toString()
                  },
                  {
                    EK: 'sourceType',
                    EV: this.sourceType.toString()
                  },
                  {
                    EK: 'sourcePlat',
                    EV: this.sourcePlat.toString()
                  },
                  {
                    EK: 'globalPlatform',
                    EV: this.global_platform.toString()
                  },
                  {
                    EK: 'pageSeq',
                    EV: this.pageSeq
                  },
                  {
                    EK: 'channelId',
                    EV: this.channel_id
                  },
                  {
                    EK: 'companyId',
                    EV: this.company_id
                  },
                  {
                    EK: 'companyName',
                    EV: this.company_name
                  },
                  {
                    EK: 'phoneProvince',
                    EV: this.province
                  },
                  {
                    EK: 'phoneCity',
                    EV: this.city
                  },
                  {
                    EK: 'setGeneralProps',
                    EV: {
                      globalTypes: '1',
                      globalOptType: '1'
                    }
                  },
                  {
                    EK: 'bussinessProcessing',
                    EV: {
                      processId: this.step,
                      processType: '8',
                      apiId: 'SDK',
                      apiName: '办理SDK',
                      resultCode: '0',
                      phoneNumber: this.encryptedPhone,
                      payMethod: '3',
                      fee: '20',
                      channelId: this.channel_id,
                      cpId: '999999',
                      orderId: response.data.miguOrderId,
                      goodsId: response.data.productId,
                      goodsName: '咪咕悦看超级会员'
                    }
                  }
                ])
                window.gdp('track', 'professional_merchants_bussinessProcessing', {
                  businessType_var: '存量', // 属于存量业务则写“存量”
                  goodsId_var: this.goodsId_var, // 业务办理时所属的商品ID或者业务ID
                  goodsName_var: this.goodsName_var, // 业务办理时商品名称。
                  goodsType_var: '新业务', // 业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
                  apiId_var: 'SDK', // 调用接口id；如果是通过SDK办理的，该字段传【SDK】
                  apiName_var: '办理SDK', // 调用接口名称；如果是通过SDK办理的，该字段传【办理SDK】
                  merchantsId_var: this.merchantsId_var, // 商品所属商户id或者渠道号
                  merchants_var: this.merchants_var, // 商品所属商户名称或者渠道名称
                  merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
                  phoneNumber_var: this.encryptPhone(), // 输入电话号码,传AES加密后的手机号
                  processType_var: '办理成功', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码(点击输入框时触发)、立即办理、前往办理(拉起统一支付页面时触发)、获取短信验证码、输入短信验证码、提交订单、办理成功、办理失败、支付成功、支付失败等）
                  errorMessage_var: '', // 业务办理失败时的失败原因明细。（如：网络问题、业务互斥……）
                  channelId_var: '', // 下单渠道编码，没有则不传
                  operatorId_var: '', // 下单工号，没有则不传
                  payType_var: '话费', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
                  merchantsOrder_var: '', // 自建的订单号。
                  orderNumber_var: response.data.miguOrderId, // 接口返回的订单号。
                  ordertype_var: '新业务订单' // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
                })

                this.showToast = true
                this.step = this.step + 1
                if (this.phone !== '' && this.orderId !== '') {
                  window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
                    {
                      EK: 'sdkTraceId',
                      EV: this.sdkTraceId.toString()
                    },
                    {
                      EK: 'entrySource',
                      EV: this.entrySource.toString()
                    },
                    {
                      EK: 'sourceType',
                      EV: this.sourceType.toString()
                    },
                    {
                      EK: 'sourcePlat',
                      EV: this.sourcePlat.toString()
                    },
                    {
                      EK: 'globalPlatform',
                      EV: this.global_platform.toString()
                    },
                    {
                      EK: 'pageSeq',
                      EV: this.pageSeq
                    },
                    {
                      EK: 'channelId',
                      EV: this.channel_id
                    },
                    {
                      EK: 'companyId',
                      EV: this.company_id
                    },
                    {
                      EK: 'companyName',
                      EV: this.company_name
                    },
                    {
                      EK: 'setGeneralProps',
                      EV: {
                        globalTypes: '1',
                        globalOptType: '1'
                      }
                    },
                    {
                      EK: 'bussinessProcessing',
                      EV: {
                        processId: this.step,
                        processType: '9',
                        apiId: 'SDK',
                        apiName: '办理SDK',
                        resultCode: '0',
                        phoneNumber: this.encryptedPhone,
                        payMethod: '3',
                        fee: '20',
                        channelId: this.channel_id,
                        cpId: '999999',
                        orderId: this.orderId,
                        goodsId: this.goodsId,
                        goodsName: '咪咕悦看超级会员'
                      }
                    }

                  ])
                }
                const stayTime = Date.now() - this.pageEnterTime

                window.AmberWebSdk._amberTrack('qingyuan_page_stay',
                  [
                    {
                      EK: 'stayTime',
                      EV: stayTime
                    },
                    {
                      EK: 'sdkTraceId',
                      EV: this.sdkTraceId.toString()
                    },
                    {
                      EK: 'entrySource',
                      EV: this.entrySource.toString()
                    },
                    {
                      EK: 'sourceType',
                      EV: this.sourceType.toString()
                    },
                    {
                      EK: 'sourcePlat',
                      EV: this.sourcePlat.toString()
                    },
                    {
                      EK: 'globalPlatform',
                      EV: this.global_platform.toString()
                    },
                    {
                      EK: 'pageSeq',
                      EV: this.pageSeq
                    },
                    {
                      EK: 'channelId',
                      EV: this.channel_id
                    },
                    {
                      EK: 'companyId',
                      EV: this.company_id
                    },
                    {
                      EK: 'companyName',
                      EV: this.company_name
                    }
                  ])
              } else {
                loading.close()
                window.gdp('track', 'professional_merchants_bussinessProcessing', {
                  businessType_var: '存量', // 属于存量业务则写“存量”
                  goodsId_var: this.goodsId_var, // 业务办理时所属的商品ID或者业务ID
                  goodsName_var: this.goodsName_var, // 业务办理时商品名称。
                  goodsType_var: '新业务', // 业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
                  apiId_var: 'SDK', // 调用接口id；如果是通过SDK办理的，该字段传【SDK】
                  apiName_var: '办理SDK', // 调用接口名称；如果是通过SDK办理的，该字段传【办理SDK】
                  merchantsId_var: this.merchantsId_var, // 商品所属商户id或者渠道号
                  merchants_var: this.merchants_var, // 商品所属商户名称或者渠道名称
                  merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
                  phoneNumber_var: this.encryptPhone(), // 输入电话号码,传AES加密后的手机号
                  processType_var: '办理失败', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码(点击输入框时触发)、立即办理、前往办理(拉起统一支付页面时触发)、获取短信验证码、输入短信验证码、提交订单、办理成功、办理失败、支付成功、支付失败等）
                  errorMessage_var: msg, // 业务办理失败时的失败原因明细。（如：网络问题、业务互斥……）
                  channelId_var: '', // 下单渠道编码，没有则不传
                  operatorId_var: '', // 下单工号，没有则不传
                  payType_var: '', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
                  merchantsOrder_var: '', // 自建的订单号。
                  orderNumber_var: response.data.miguOrderId, // 接口返回的订单号。
                  ordertype_var: '新业务订单' // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
                })
                window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
                  {
                    EK: 'sdkTraceId',
                    EV: this.sdkTraceId.toString()
                  },
                  {
                    EK: 'entrySource',
                    EV: this.entrySource.toString()
                  },
                  {
                    EK: 'sourceType',
                    EV: this.sourceType.toString()
                  },
                  {
                    EK: 'sourcePlat',
                    EV: this.sourcePlat.toString()
                  },
                  {
                    EK: 'globalPlatform',
                    EV: this.global_platform.toString()
                  },
                  {
                    EK: 'pageSeq',
                    EV: this.pageSeq
                  },
                  {
                    EK: 'channelId',
                    EV: this.channel_id
                  },
                  {
                    EK: 'companyId',
                    EV: this.company_id
                  },
                  {
                    EK: 'companyName',
                    EV: this.company_name
                  },
                  {
                    EK: 'phoneProvince',
                    EV: this.province
                  },
                  {
                    EK: 'phoneCity',
                    EV: this.city
                  },
                  {
                    EK: 'setGeneralProps',
                    EV: {
                      globalTypes: '1',
                      globalOptType: '1'
                    }
                  },
                  {
                    EK: 'bussinessProcessing',
                    EV: {
                      processId: this.step,
                      processType: '8',
                      apiId: 'SDK',
                      apiName: '办理SDK',
                      phoneNumber: this.encryptedPhone,
                      resultCode: '1',
                      errorMessage: msg,
                      payMethod: '3',
                      fee: '20',
                      channelId: this.channel_id,
                      cpId: '999999',
                      orderId: response.data.miguOrderId,
                      goodsId: response.data.productId,
                      goodsName: '咪咕悦看超级会员'
                    }
                  }
                ])
                if (msg === '取消支付') {
                  this.step = this.step + 1
                  window.AmberWebSdk._amberTrack('qingyuan_traceLog', [
                    {
                      EK: 'sdkTraceId',
                      EV: this.sdkTraceId.toString()
                    },
                    {
                      EK: 'entrySource',
                      EV: this.entrySource.toString()
                    },
                    {
                      EK: 'sourceType',
                      EV: this.sourceType.toString()
                    },
                    {
                      EK: 'sourcePlat',
                      EV: this.sourcePlat.toString()
                    },
                    {
                      EK: 'globalPlatform',
                      EV: this.global_platform.toString()
                    },
                    {
                      EK: 'pageSeq',
                      EV: this.pageSeq
                    },
                    {
                      EK: 'channelId',
                      EV: this.channel_id
                    },
                    {
                      EK: 'companyId',
                      EV: this.company_id
                    },
                    {
                      EK: 'companyName',
                      EV: this.company_name
                    },
                    {
                      EK: 'phoneProvince',
                      EV: this.province
                    },
                    {
                      EK: 'phoneCity',
                      EV: this.city
                    },
                    {
                      EK: 'setGeneralProps',
                      EV: {
                        globalTypes: '1',
                        globalOptType: '1'
                      }
                    },
                    {
                      EK: 'bussinessProcessing',
                      EV: {
                        processId: this.step,
                        processType: '10',
                        apiId: 'SDK',
                        apiName: '办理SDK',
                        phoneNumber: this.encryptedPhone,
                        resultCode: '1',
                        errorMessage: msg,
                        payMethod: '3',
                        fee: '20',
                        channelId: this.channel_id,
                        cpId: '999999',
                        orderId: response.data.miguOrderId,
                        goodsId: response.data.productId,
                        goodsName: '咪咕悦看超级会员'
                      }
                    }
                  ])
                }

                this.$message({
                  message: '支付失败',
                  type: 'error',
                  center: true,
                  offset: window.screen.height / 2
                })
              }
            })
          }
        } else {
          loading.close()
          this.$message({
            message: response.msg,
            type: 'error',
            center: true,
            offset: window.screen.height / 2
          })
          window.AmberWebSdk._amberTrack('qingyuan_user_login', [
            {
              EK: 'account',
              EV: this.encryptedPhone
            },
            {
              EK: 'accountType',
              EV: '1'
            },
            {
              EK: 'phoneNumber',
              EV: this.encryptedPhone
            },
            {
              EK: 'resultCode',
              EV: '1'
            },
            {
              EK: 'sdkTraceId',
              EV: this.sdkTraceId.toString()
            },
            {
              EK: 'entrySource',
              EV: this.entrySource.toString()
            },
            {
              EK: 'sourceType',
              EV: this.sourceType.toString()
            },
            {
              EK: 'sourcePlat',
              EV: this.sourcePlat.toString()
            },
            {
              EK: 'globalPlatform',
              EV: this.global_platform.toString()
            },
            {
              EK: 'pageSeq',
              EV: this.pageSeq
            },
            {
              EK: 'channelId',
              EV: this.channel_id
            },
            {
              EK: 'companyId',
              EV: this.company_id
            },
            {
              EK: 'companyName',
              EV: this.company_name
            },
            {
              EK: 'phoneProvince',
              EV: this.province
            },
            {
              EK: 'phoneCity',
              EV: this.city
            }
          ])
        }
      } catch (error) {
        console.error(error)
        this.$message({
          message: error,
          type: 'error',
          center: true,
          offset: window.screen.height / 2
        })
        window.AmberWebSdk._amberTrack('qingyuan_user_login', [
          {
            EK: 'account',
            EV: this.encryptedPhone
          },
          {
            EK: 'accountType',
            EV: '1'
          },
          {
            EK: 'phoneNumber',
            EV: this.encryptedPhone
          },
          {
            EK: 'resultCode',
            EV: '1'
          },
          {
            EK: 'sdkTraceId',
            EV: this.sdkTraceId.toString()
          },
          {
            EK: 'entrySource',
            EV: this.entrySource.toString()
          },
          {
            EK: 'sourceType',
            EV: this.sourceType.toString()
          },
          {
            EK: 'sourcePlat',
            EV: this.sourcePlat.toString()
          },
          {
            EK: 'globalPlatform',
            EV: this.global_platform.toString()
          },
          {
            EK: 'pageSeq',
            EV: this.pageSeq
          },
          {
            EK: 'channelId',
            EV: this.channel_id
          },
          {
            EK: 'companyId',
            EV: this.company_id
          },
          {
            EK: 'companyName',
            EV: this.company_name
          },
          {
            EK: 'phoneProvince',
            EV: this.province
          },
          {
            EK: 'phoneCity',
            EV: this.city
          }
        ])
      }
    }
  },
  beforeRouteLeave (to: any, from: any, next: any) {
    this.uploadPageStayTime()
    next()
  },
  mounted () {
    const loading = ElLoading.service({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    // 1. 初始化基础数据
    this.pageEnterTime = Date.now()
    // 1. 获取当前页面的完整 URL (包含协议、域名、路径和参数)
    const currentUrl = window.location.href

    // 2. 进行 Base64 编码
    this.entrySource = encodeBase64(currentUrl)

    console.log('用户首次打开的页面URL:', currentUrl)
    console.log('编码后的 entrySource:', this.entrySource)

    // 2. 【关键】严格按照文档 [4] 1.1.1 集成 Amber SDK
    // 定义 _mgds 队列并推入配置
    const _mgds = (window as any)._mgds || [];
    (window as any)._mgds = _mgds

    const etm = 1 * Date.now()
    _mgds.push(['_enterUpTime', etm]) // 注意：文档示例用的是 _enterTime，但部分 SDK 版本用 _enterUpTime，请根据实际 SDK 代码调整，通常为 _enterTime
    _mgds.push(['_accountId', 'qyzx3b4728d5421094246539b79cefba']) // 渠道唯一标识
    _mgds.push(['_isInBrowser', 'true']) // 标识为浏览器访问
    _mgds.push(['_inAppIsUpload', 'false'])
    _mgds.push(['_inAppIsUpload', 'false'])
    // _mgds.push(['_uploadUrl', 'http://117.135.165.39:8088/udcc/qyWebData.html'])//测试环境
    _mgds.push(['_uploadUrl', 'https://uem.migu.cn:18088/udcc/qyWebData.html'])// 生产环境
    // 3. 异步加载 SDK 脚本 (注意：这里必须放在配置 push 之后)
    const vds = document.createElement('script')
    vds.type = 'text/javascript'
    vds.async = true

    // 注意：当前指向测试环境，上线前请切换为生产环境地址
    vds.src = 'https://ambersdk.migu.cn/uemjs/xk/amber-web-sdk-min.js'

    const s = document.getElementsByTagName('script')[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(vds, s)
    }

    console.log(vds)
    console.log(_mgds)
    // 4. SDK 加载完成回调
    vds.onload = (ev) => {
      console.log(ev)
      // 4.1 获取链路ID (文档 5.1)
      // 同步获取SDK追踪ID
      this.sdkTraceId = window.AmberWebSdk.getSdkTraceId()
      console.log(this.sdkTraceId)

      // 4.2 【重要】上报页面加载事件 (文档 5.3.2)

      // 4.3 执行原本的页面计算逻辑
      this.calculatePageLoadTime()

      // 5. MiguSdk 数据获取逻辑 (保持不变，建议在获取数据后上报登录事件)
      try {
        const script = document.createElement('script')
        script.src = 'https://cdn3.cmread.com/opf-meta/upload/24/1115/10/55/51/241115105551442f116.js'
        script.onload = () => {
          console.log('MiguSdk loaded', window.MiguSdk)

          const json = {
            channelCode: this.chanelId,
            sdkType: 'https',
            domain: 'mgread.5252vip.com',
            option: {
              umark: 'Common2',
              color: '',
              sdkTraceId: this.sdkTraceId
            }

          }

          window.MiguSdk.getData(json, (resultCode, msg, authSessionId) => {
            /** 二次处理 */
            loading.close()
            console.log(resultCode.toString())
            if (resultCode.toString() !== '0000') {
              this.$message({
                message: '加载失败',
                type: 'error',
                center: true,
                offset: window.screen.height / 2
              })
            }
          })
        }
        document.head.appendChild(script)

        const script2 = document.createElement('script')
        script2.src = 'https://assets.giocdn.com/sdk/webjs/cdp/gdp-full.js'
        // script.src = 'http://static.st.cmread.com:8117/comment/js/5539fae9a36ba9a70553a0054c04ea05d3588cb4718b/migusdk.js'
        script2.onload = () => {
          console.log('MiguSdk loaded', window.gdp)
          // 在此处调用 MiguSdk 的方法

          window.gdp('init', this.projectId, this.DatasourceId, {
            host: this.ServerHost, // 数据发送地址。
            compress: true, // 开启数据压缩模式。
            debug: true, // 开启测试模式，控制台可看到数据，生产环境请勿添加此参数。
            hashtag: true, // 开启页面URL混淆采集
            scheme: 'https' // http页面加此参数
          })

          window.gdp('setGeneralProps', {
            global_merchantsId_var: this.global_merchantsId_var, // 商户id
            global_merchants_var: this.global_merchants_var, // 商户名称
            global_merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
            global_apiId_var: 'SDK', // 调用接口id；传产品受理的接口ID
            global_apiName_var: '办理SDK'// 调用接口名称；传产品受理的接口名称
          })

          window.gdp('track', 'professional_merchants_pageView', {
            pageName_var: this.pageName_var, // 页面访问时当前页面名称，传具体的页面名称。
            merchantsId_var: this.merchantsId_var, // 商品所属商户id。
            merchants_var: this.merchants_var, // 商品所属商户名称。
            merchantsIdCity_var: this.merchantsIdCity_var// 商户ID归属地市，枚举值：省统、广州、中山、云浮……
          })

          window.gdp('track', 'professional_merchants_bussinessProcessing', {
            businessType_var: '存量', // 属于存量业务则写“存量”
            goodsId_var: this.goodsId_var, // 业务办理时所属的商品ID或者业务ID
            goodsName_var: this.goodsName_var, // 业务办理时商品名称。
            goodsType_var: '新业务', // 业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
            apiId_var: 'SDK', // 调用接口id；如果是通过SDK办理的，该字段传【SDK】
            apiName_var: '办理SDK', // 调用接口名称；如果是通过SDK办理的，该字段传【办理SDK】
            merchantsId_var: this.merchantsId_var, // 商品所属商户id或者渠道号
            merchants_var: this.merchants_var, // 商品所属商户名称或者渠道名称
            merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
            phoneNumber_var: '', // 输入电话号码,传AES加密后的手机号
            processType_var: '页面浏览', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码(点击输入框时触发)、立即办理、前往办理(拉起统一支付页面时触发)、获取短信验证码、输入短信验证码、提交订单、办理成功、办理失败、支付成功、支付失败等）
            errorMessage_var: '', // 业务办理失败时的失败原因明细。（如：网络问题、业务互斥……）
            channelId_var: '', // 下单渠道编码，没有则不传
            operatorId_var: '', // 下单工号，没有则不传
            payType_var: '话费', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
            merchantsOrder_var: '', // 自建的订单号。
            orderNumber_var: '', // 接口返回的订单号。
            ordertype_var: '新业务订单' // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
          })
        }
        document.head.appendChild(script2)
      } catch (error) {
        console.error('Failed to load MiguSdk:', error)
      }
    }

    vds.onerror = () => {
      this.sdkTraceId = ''
      console.warn('SDK load failed, sdkTraceId not available')
      this.calculatePageLoadTime()
      loading.close()
      try {
        const script = document.createElement('script')
        script.src = 'https://cdn3.cmread.com/opf-meta/upload/24/1115/10/55/51/241115105551442f116.js'
        script.onload = () => {
          console.log('MiguSdk loaded', window.MiguSdk)

          const json = {
            channelCode: this.chanelId,
            sdkType: 'https',
            domain: 'mgread.5252vip.com',
            option: {
              umark: 'Common2',
              color: '',
              sdkTraceId: this.sdkTraceId
            }

          }

          window.MiguSdk.getData(json, (resultCode, msg, authSessionId) => {
            /** 二次处理 */
            loading.close()
            console.log(resultCode.toString())
            if (resultCode.toString() !== '0000') {
              this.$message({
                message: '加载失败',
                type: 'error',
                center: true,
                offset: window.screen.height / 2
              })
            }
          })
        }
        document.head.appendChild(script)

        const script2 = document.createElement('script')
        script2.src = 'https://assets.giocdn.com/sdk/webjs/cdp/gdp-full.js'
        // script.src = 'http://static.st.cmread.com:8117/comment/js/5539fae9a36ba9a70553a0054c04ea05d3588cb4718b/migusdk.js'
        script2.onload = () => {
          console.log('MiguSdk loaded', window.gdp)
          // 在此处调用 MiguSdk 的方法

          window.gdp('init', this.projectId, this.DatasourceId, {
            host: this.ServerHost, // 数据发送地址。
            compress: true, // 开启数据压缩模式。
            debug: true, // 开启测试模式，控制台可看到数据，生产环境请勿添加此参数。
            hashtag: true, // 开启页面URL混淆采集
            scheme: 'https' // http页面加此参数
          })

          window.gdp('setGeneralProps', {
            global_merchantsId_var: this.global_merchantsId_var, // 商户id
            global_merchants_var: this.global_merchants_var, // 商户名称
            global_merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
            global_apiId_var: 'SDK', // 调用接口id；传产品受理的接口ID
            global_apiName_var: '办理SDK'// 调用接口名称；传产品受理的接口名称
          })

          window.gdp('track', 'professional_merchants_pageView', {
            pageName_var: this.pageName_var, // 页面访问时当前页面名称，传具体的页面名称。
            merchantsId_var: this.merchantsId_var, // 商品所属商户id。
            merchants_var: this.merchants_var, // 商品所属商户名称。
            merchantsIdCity_var: this.merchantsIdCity_var// 商户ID归属地市，枚举值：省统、广州、中山、云浮……
          })

          window.gdp('track', 'professional_merchants_bussinessProcessing', {
            businessType_var: '存量', // 属于存量业务则写“存量”
            goodsId_var: this.goodsId_var, // 业务办理时所属的商品ID或者业务ID
            goodsName_var: this.goodsName_var, // 业务办理时商品名称。
            goodsType_var: '新业务', // 业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
            apiId_var: 'SDK', // 调用接口id；如果是通过SDK办理的，该字段传【SDK】
            apiName_var: '办理SDK', // 调用接口名称；如果是通过SDK办理的，该字段传【办理SDK】
            merchantsId_var: this.merchantsId_var, // 商品所属商户id或者渠道号
            merchants_var: this.merchants_var, // 商品所属商户名称或者渠道名称
            merchantsIdCity_var: this.merchantsIdCity_var, // 商户ID归属地市，枚举值：省统、广州、中山、云浮……
            phoneNumber_var: '', // 输入电话号码,传AES加密后的手机号
            processType_var: '页面浏览', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码(点击输入框时触发)、立即办理、前往办理(拉起统一支付页面时触发)、获取短信验证码、输入短信验证码、提交订单、办理成功、办理失败、支付成功、支付失败等）
            errorMessage_var: '', // 业务办理失败时的失败原因明细。（如：网络问题、业务互斥……）
            channelId_var: '', // 下单渠道编码，没有则不传
            operatorId_var: '', // 下单工号，没有则不传
            payType_var: '话费', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
            merchantsOrder_var: '', // 自建的订单号。
            orderNumber_var: '', // 接口返回的订单号。
            ordertype_var: '新业务订单' // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
          })
        }
        document.head.appendChild(script2)
      } catch (error) {
        console.error('Failed to load MiguSdk:', error)
      }
    }

    window.addEventListener('beforeunload', this.handlePageUnload)
  },
  beforeUnmount () {
    window.removeEventListener('beforeunload', this.handlePageUnload)
  }
})
export default class Sketch extends Vue {
}
</script>
<style scoped lang="scss">
.home {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  background-color: #df2b14;
}

:deep(.home .el-main ) {
  padding: 0;
  margin: 0;
}

:deep(.home .el-container ) {
  padding: 0;
  margin: 0;
}

.el_col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.el_row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.el_phone_input {
  width: 80%;
  height: 70px;
  font-size: 24px;
}

:deep(.el_phone_input .el-input__wrapper) {
  border-radius: 30px;
}

.el_code_input {
  width: 60%;
  height: 70px;
  font-size: 24px;
  margin-top: 30px;
}

:deep(.el_code_input .el-input__wrapper) {
  border-radius: 30px 0 0 30px;
}

.img {
  width: 80%;
  margin-top: 15px;
}

.img_title {
  width: 100%;
}

.font_size {
  font-size: 16px;
  color: white;
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 0px;
  margin-bottom: 10px;
  text-align: left;
}

strong {
  font-size: 16px;
  color: rgba(246, 215, 6, 0.8);
}

</style>
